import { render, staticRenderFns } from "./suggestions.vue?vue&type=template&id=ab12634a&scoped=true"
import script from "./suggestions.vue?vue&type=script&lang=js"
export * from "./suggestions.vue?vue&type=script&lang=js"
import style0 from "./suggestions.vue?vue&type=style&index=0&id=ab12634a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab12634a",
  null
  
)

export default component.exports